import type { IHttpClient } from '@blufin/types';
import { createContext } from 'react';

export const HttpContextAlpha = createContext<IHttpClient | null>(null);
